import { getAkamaiImageManagerSrc } from './getAkamaiImageManagerSrc';
const resolutionMappings = {
    80: '80',
    124: '124',
    264: '264',
    396: '396',
    564: '564',
    657: '657',
    768: '768',
    820: '820',
    1260: '1260',
    1536: '1536',
    2160: '2160',
};
export const sizes = Object.keys(resolutionMappings);
export const wrapProductImageImageManagerImageSrc = (src, closestWidth) => {
    return getAkamaiImageManagerSrc(src, resolutionMappings[closestWidth]);
};
//# sourceMappingURL=productImageImageManagerMappings.js.map